'use client';

import { twMerge } from 'tailwind-merge';
import { socialIcons } from '../../../utils/socials';
import { appConfig } from '../../../config';
import Link from 'next/link';
import { useState } from 'react';
import Share from '../../components/svg/socials/Share';
import { IAuthor } from '../../../models/IAuthor';



export default function SocialsShare({className, writerSocials}: {className?: string; writerSocials?: IAuthor['socials']}) {
  const [expanded, setExpanded] = useState(false);
  if (!writerSocials?.length) return null;

  const allowedSocials = [4,1,2,3,6];
  const socials = socialIcons.filter(s => allowedSocials.includes(s.type));
  const displayedSocials = socials?.length ? socials.filter(s => writerSocials.find(ws => ws.type === s.type)) : [];

  return (
      <div className={twMerge('flex flex-col gap-[8px] w-fit mx-auto', className)}>
          <div className='flex gap-[24px] [&>*]:grid [&>*]:place-items-center [&>*]:rounded-[4px] [&>*]:w-[24px] [&>*]:aspect-square [&>*]:cursor-pointer rounded-[4px]'>
          {displayedSocials.map(({ShareComponent, type, title}) => <Link title={title} target='_blank' href={writerSocials.find(ws => ws.type === type)?.url || ''}><ShareComponent className='[&>*]:h-[24px] [&>*]:w-[24px]'/></Link>)}
          {/* {displayedSocials.length > 2 ? <Share onClick={() => setExpanded(!expanded)}/> : null} */}
            </div>
      </div>
  )
}